import { render, staticRenderFns } from "./PaymentChannel.vue?vue&type=template&id=b9c3c6a2&scoped=true&"
import script from "./PaymentChannel.vue?vue&type=script&lang=js&"
export * from "./PaymentChannel.vue?vue&type=script&lang=js&"
import style0 from "./PaymentChannel.vue?vue&type=style&index=0&id=b9c3c6a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c3c6a2",
  null
  
)

export default component.exports